const mapSubscriptionItems = (items) => items.reduce((acc, item, index) => {
	if (item.isOneTimeRemoved) return acc;
	const { variantShopifyId, quantity, discountedPrice } = item;
	if (acc[variantShopifyId]) {
		acc[variantShopifyId].isDuplicated = true;
		acc[variantShopifyId].duplicates.push(item);
		acc[variantShopifyId].discountedPrice = acc[variantShopifyId].discountedPrice + discountedPrice;
		acc[variantShopifyId].totalQuantity = acc[variantShopifyId].totalQuantity + quantity;
	} else
		acc[variantShopifyId] = { ...item, duplicates: [], updating: false, totalQuantity: quantity, index };

	return acc;
}, {});

export default mapSubscriptionItems;